import React, { useEffect, useState } from "react";
import connect from "react-redux/es/connect/connect";
import {Redirect} from "react-router-dom";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Tooltip, Fab } from "@mui/material";

// @mui/icons-material
import { AddRounded } from "@mui/icons-material";

// core components
import Card from 'components/card/card';
import CardBody from 'components/card/cardBody';
import CardHeader from 'components/card/cardHeader';
import CreateDialog from './components/createDialog';
import GlobalAction from "./components/globalAction";
import GridContainer from 'components/grid/gridContainer';
import GridItem from 'components/grid/gridItem';
import ListLoader from '../configuration/components/listLoader';
import Notification from "./components/notification";
import DeleteErrorNotification from "./components/deleteErrorNotification";
import Search from '../configuration/components/search';
import AttributeExportButton from "components/attributeExport/AttributeExportButton";
import TableHead from '../configuration/components/tableHead';
import TableBody  from "./components/tableBody";

// styles
import listStyle from "assets/jss/views/configuration/defaultListStyle";
import 'assets/css/ckeditor.css';

// actions
import { categoryList } from "actions/category/list";

// utils
import {Authorizations, hasAuthorization} from "../../utils/authorizations";
import {withStyles} from "@mui/styles";

function List (props) {
    const {
        categoryList,
        classes,
        created,
        deleted,
        deletedSelection,
        loading,
        retrieved,
        updated,
        updatedPosition,
        updatePositionLoading,
    } = props;

    const [createDialog, showCreateDialog] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [search, setSearch] = useState('');
    const [checkedCategories, setCheckedCategories] = useState([]);

    useEffect(() => {
        categoryList("retailer=&order[position]=asc&pagination=false&draft=false");
        setShowNotification(true);
    }, [created, deleted, updated, deletedSelection, updatedPosition, categoryList]);

    if (false === hasAuthorization(props.authorizations, Authorizations.GLOBAL_ORGANIZATION_ESHOP_MANAGEMENT)
        && false === hasAuthorization(props.authorizations, Authorizations.MARKETPLACE_CATEGORY_MANAGEMENT)
    ) {
        return <Redirect to={'/'} />;
    }

    return (
        <div className={classes.containerWithSidebar}>
            <div className={classes.container}>
                <Notification isOpen={showNotification} closeNotification={() => setShowNotification(false)} />
                <DeleteErrorNotification />
                <GridContainer>
                    <GridItem xs={12}>
                        <Card className={classes.card}>
                            <CardHeader color="info">
                                <GridContainer>
                                    <GridItem xs={9} sm={10}>
                                        <h3>
                                            <FormattedMessage id={"category.title"} />
                                        </h3>
                                    </GridItem>
                                    {hasAuthorization(props.authorizations, Authorizations.MARKETPLACE_CATEGORY_MANAGEMENT) && (
                                        <GridItem xs={3} sm={2} className={classes.mainActionsContainer}>
                                            <Fab onClick={() => showCreateDialog(true)} color={"primary"}>
                                                <Tooltip title={<FormattedMessage id={"category.add.category"} />}>
                                                    <AddRounded fontSize={"large"} />
                                                </Tooltip>
                                            </Fab>
                                        </GridItem>
                                    )}
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                <div className={classes.subTableContainer}>
                                    {checkedCategories.length > 0 && (
                                        <GlobalAction categories={checkedCategories} />
                                    )}
                                    <AttributeExportButton type={'categories'} />
                                    <Search
                                        attributeName={"category"}
                                        search={search}
                                        setSearch={setSearch}
                                    />
                                </div>
                                <div className={classes.spacer}></div>
                                <div className={classes.tableWrapper}>
                                    {!retrieved && <ListLoader loading={loading || updatePositionLoading} />}
                                    <div>
                                        <TableHead
                                            listLoading={retrieved && (loading || updatePositionLoading)}
                                            headers={[
                                                "category.table.header.name",
                                                "category.table.header.description",
                                                "category.table.header.date",
                                            ]}
                                        />
                                        <TableBody
                                            retrieved={retrieved}
                                            search={search}
                                            checkedCategories={checkedCategories}
                                            setCheckedCategories={setCheckedCategories}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
            <CreateDialog closeDialog={() => showCreateDialog(false)} isOpen={createDialog} />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        retrieved: state.category.list.retrieved,
        loading: state.category.list.loading,
        created: state.category.create.created,
        deleted: state.category.deleteCategory.deleted,
        updated: state.category.update.updated,
        updatedPosition: state.category.updatePosition.updated,
        updatePositionLoading: state.category.updatePosition.loading,
        deletedSelection: state.category.deleteSelection.deleted,
        authorizations: state.authentication.authorizations,
    };
};

const mapDispatchToProps = dispatch => ({
    categoryList: params => dispatch(categoryList(params)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(listStyle)(List));
